// extracted by mini-css-extract-plugin
module.exports = {"root":"jw5smU22kxBqe6r2W0s2"};